// extracted by mini-css-extract-plugin
export default {"disabled":"PaymentOptions--disabled--f9ceac"};